// import components
import PlanningCycleDialog from 'components/shared/PlanningCycle/PlanningCycleDialog';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import PlanningCycleInfo from 'components/admin-portal/Settings/Match/components/PlanningCycleInfo';

// import hooks
import { t } from 'i18next';

const PlanningCycle = ({
  isPublishedEnabled,
  setIsPublishedEnabled,
  isVisibleEnabled,
  setIsVisibleEnabled,
  handleDialogOpen,
  handleCheckboxChange,
  handleDialogClose,
  openPlanningCycleDialog,
  costCenterId,
  publishedCycle,
  visibleCycle
}) => {
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h6">{t('recurrenceDialog.title')}</Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={isPublishedEnabled}
            onChange={(e) => {
              if (e.target.checked) {
                handleDialogOpen('PUBLISHED');
              } else {
                setIsPublishedEnabled(false);
                handleCheckboxChange('PUBLISHED', false);
              }
            }}
          />
        }
        label={t('recurrenceDialog.publish')}
      />

      {publishedCycle && isPublishedEnabled && (
        <PlanningCycleInfo
          planningCycle={publishedCycle}
          onEditClick={() => handleDialogOpen('PUBLISHED')}
          isChecked={isPublishedEnabled}
          onCheckboxChange={(e) => setIsPublishedEnabled(e.target.checked)}
        />
      )}

      <FormControlLabel
        control={
          <Checkbox
            checked={isVisibleEnabled}
            onChange={(e) => {
              if (e.target.checked) {
                handleDialogOpen('VISIBLE');
              } else {
                setIsVisibleEnabled(false);
                handleCheckboxChange('VISIBLE', false);
              }
            }}
          />
        }
        label={t('recurrenceDialog.visible')}
      />

      {visibleCycle && isVisibleEnabled && (
        <PlanningCycleInfo
          planningCycle={visibleCycle}
          onEditClick={() => handleDialogOpen('VISIBLE')}
          isChecked={isVisibleEnabled}
          onCheckboxChange={(e) => setIsVisibleEnabled(e.target.checked)}
        />
      )}

      <PlanningCycleDialog
        open={openPlanningCycleDialog.published}
        onHidden={(wasSaved) => handleDialogClose('PUBLISHED', wasSaved)}
        type="PUBLISHED"
        costCenterId={costCenterId}
        currentPlanningCycle={publishedCycle}
      />

      <PlanningCycleDialog
        open={openPlanningCycleDialog.visible}
        onHidden={(wasSaved) => handleDialogClose('VISIBLE', wasSaved)}
        type="VISIBLE"
        costCenterId={costCenterId}
        currentPlanningCycle={visibleCycle}
      />
    </Box>
  );
};

export default PlanningCycle;
